import { css } from "@emotion/react";

export const hover = css`
	filter: brightness(1);
	transition: filter 100ms ease-in-out;
	:hover {
		filter: brightness(1.1);
	}
`;
